import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { MultiSelectPopoverDeprComponent } from '../multi-select-popover-depr/multi-select-popover-depr.component';
import { TRenderOptionType, TSelectFilterGroupInfo } from '../filter/model/ui-filter.types';
import { TFilterSelected } from '@monorepo/types';
import { createThrottler } from '@monorepo/utils';

/**
 * @deprecated
 * Note: Below will be deprected and deleted since 'monorepo-inline-multi-select' supports localization and is more generic
 */
@Component({
  selector: 'monorepo-inline-multi-select-depr',
  templateUrl: './inline-multi-select-depr.component.html',
  styleUrls: ['./inline-multi-select-depr.component.scss'],
})
export class InlineMultiSelectDeprComponent {
  @Input() inlineMultiSelectInput!: TSelectFilterGroupInfo;
  @Input() selectedFilters!: TFilterSelected[];
  @Input() popoverRenderOptionType: TRenderOptionType = 'MODAL';
  @Output() selectedItemsEvent = new EventEmitter<TSelectFilterGroupInfo>();
  #throttle = createThrottler();

  constructor(public popoverController: PopoverController, private modalController: ModalController) {}

  getPopoverOptionList(option: TSelectFilterGroupInfo['items'][number]): TSelectFilterGroupInfo['items'][number] {
    return {
      ...option,
      displayText: option.displayText ? option.displayText : option.value.toString(),
    };
  }

  onSelection(data: TSelectFilterGroupInfo['items']) {
    const selectedItems = data.filter((option) => option.isSelected).map((option) => option.value);
    const multiSelectData = {
      ...this.inlineMultiSelectInput,
      items: data,
      selectedValues: selectedItems,
    };
    this.selectedItemsEvent.emit(multiSelectData);
  }

  async presentPopover(ev: Event) {
    switch (this.popoverRenderOptionType) {
      case 'INLINE':
        await this.#throttle('popover', () => this.createPopover(ev, 'multi-select-popover-inline-depr'));
        break;
      case 'MODAL':
        this.#throttle('modal', () => this.createModal('monorepo-inline-multi-select-depr'));
        break;
    }
  }

  async createModal(cssClass: string) {
    const modal = await this.modalController.create({
      component: MultiSelectPopoverDeprComponent,
      cssClass,
      componentProps: {
        popoverInfo: this.inlineMultiSelectInput.items.map((x) => this.getPopoverOptionList(x)),
        popoverRenderOptionType: this.popoverRenderOptionType,
        virtualScroll: this.inlineMultiSelectInput.virtualScroll,
        searchWithApi: this.inlineMultiSelectInput.searchWithApi,
        filterKey: this.inlineMultiSelectInput.key ? this.inlineMultiSelectInput.key : null,
        selectedFilters: this.selectedFilters ? this.selectedFilters : null,
        limitItemsByKeystroke: this.inlineMultiSelectInput.limitItemsByKeystroke || 0,
      },
    });
    await modal.present();
    const dismissVal = await modal.onDidDismiss();
    const dimissData = dismissVal.data as TSelectFilterGroupInfo['items'];
    if (dimissData) this.onSelection(dimissData);
  }

  async createPopover(ev: Event, cssClass: string) {
    const popover = await this.popoverController.create({
      component: MultiSelectPopoverDeprComponent,
      event: ev,
      cssClass,
      animated: false,
      componentProps: {
        popoverInfo: this.inlineMultiSelectInput.items.map((x) => this.getPopoverOptionList(x)),
        popoverRenderOptionType: this.popoverRenderOptionType,
        searchWithApi: this.inlineMultiSelectInput.searchWithApi,
        filterKey: this.inlineMultiSelectInput.key ? this.inlineMultiSelectInput.key : null,
        selectedFilters: this.selectedFilters ? this.selectedFilters : null,
        limitItemsByKeystroke: this.inlineMultiSelectInput.limitItemsByKeystroke || 0,
        virtualScroll: this.inlineMultiSelectInput.virtualScroll,
      },
      translucent: true,
    });
    await popover.present();
    const dismissVal = await popover.onDidDismiss();
    const dimissData = dismissVal.data as TSelectFilterGroupInfo['items'];
    if (dimissData) this.onSelection(dimissData);
  }
}
